export default __webpack_public_path__ + "bc849ea0941ea857594e65b661a4616d.png";